import { render, staticRenderFns } from "./BotoneraExtendida.vue?vue&type=template&id=64560db8"
import script from "./BotoneraExtendida.vue?vue&type=script&lang=js"
export * from "./BotoneraExtendida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports